// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 移除重定向，直接使用Meeting组件
  {
    path: '/',
    name: 'Meeting',
    component: () => import('@/views/Meeting.vue')
  },
]

const router = new VueRouter({
  mode: 'history',  // 根据需求选择 'hash' 或 'history'
  base: process.env.BASE_URL,
  routes
})

export default router